module.exports = __webpack_public_path__ + "img/course.e13d3800.png";